import * as React from "react"
import { Box } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { formatDate } from "@ui-seeker/utils"

import { LabelCountry, LinkIconBlock } from "@components"


export default function RetailerBlock({ retailer, country, date, section, keyword, pageURL, siteURL }) {
	return <Box>
		<LabelCountry
			country={country}
			label={retailer}
			url={siteURL}
		/>
		<Box sx={{ fontSize: 13, color: "text.disabled" }}>
			{ !!date && <Box>
				Date: {formatDate(date, {isString: true})}
			</Box> }
			{ !!section && <Box>
				{section} <IconSeeker icon="arrow-up-right-from-square" sx={{ color: 'primary.main' }} />
			</Box> }
			{ !!keyword && <LinkIconBlock url={pageURL} children={keyword} linkProps={{ sx: {color: 'text.disabled'}}} /> }
		</Box>
	</Box>
}